import { EntityModel } from '@/interfaces'
import {
  ALL_WYSIWYG_BLOCKS_QUERY,
  CREATE_WYSIWYG_BLOCK_MUTATION,
  DELETE_WYSIWYG_BLOCK_MUTATION,
  FORCE_DELETE_WYSIWYG_BLOCK_MUTATION,
  SINGLE_WYSIWYG_BLOCK_QUERY,
  UPDATE_WYSIWYG_BLOCK_MUTATION,
} from './graphql'

const cmsWysiwygBlockModel: EntityModel = {
  name: 'wysiwygBlock',
  namePlural: 'wysiwygBlocks',
  uniqueName: 'cmsWysiwygBlock',
  uniqueNamePlural: 'cmsWysiwygBlocks',
  path: 'cms/blocks/wysiwyg_block',
  baseUrl: '/cms/blocks/wysiwyg_blocks',
  translationPrefix: 'entities:cmsWysiwygBlock.',
  getDisplayName: (values: any) => {
    return 'Text Block (WYSIWYG)'
  },
  gql: {
    getAll: ALL_WYSIWYG_BLOCKS_QUERY,
    getSingle: SINGLE_WYSIWYG_BLOCK_QUERY,
    create: CREATE_WYSIWYG_BLOCK_MUTATION,
    update: UPDATE_WYSIWYG_BLOCK_MUTATION,
    delete: DELETE_WYSIWYG_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_WYSIWYG_BLOCK_MUTATION,
  },
  attributes: {
    html: {
      name: 'html',
      label: 'entities:cmsWysiwygBlock.attributes.html.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default cmsWysiwygBlockModel
